import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Footer = () => {
  const [cookieSettings, setCookieSettings] = useState({
    showBanner: true,
    essentialCookies: true, 
    functionalCookies: false,
    analyticsCookies: false,
    marketingCookies: false,
    showDetails: false
  });
  const [ageIsAccepted, setAgeIsAccepted] = useState(true);
  const [showAgeError, setShowAgeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  
  // iframe için temel stil - daha makul z-index değeri
  const iframeStyles = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    border: "none",
    zIndex: 100 // Daha makul bir z-index değeri, sitenin diğer elementlerinden yüksek olmalı
  };
  
  // iframe container için stil
  const iframeContainerStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    margin: "0",
    padding: "0",
    overflow: "hidden",
    zIndex: 99, // Daha makul bir z-index değeri
    background: "#000"
  };
  
  // Sitenin diğer elementlerinin z-index değerlerini düşürmek için
  useEffect(() => {
    if (showIframe && data) {
      // Mevcut stil etiketini temizle
      const existingStyle = document.getElementById('iframe-override-style');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      // Yeni stil etiketi oluştur
      const styleElement = document.createElement('style');
      styleElement.id = 'iframe-override-style';
      styleElement.textContent = `
        /* Sitenin z-index'i yüksek olan elementlerini düşür */
        .header, .nav, .hero, .cookie-banner, .age-check-popup, .modal, 
        .fixed, .absolute, .sticky, [class*="z-"], 
        [style*="z-index"], [style*="position: fixed"], [style*="position: absolute"] {
          z-index: 0 !important;
          position: static !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
        
        /* Body stilleri */
        body, html {
          overflow: hidden !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        /* iframe container */
        #iframe-container {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          z-index: 99 !important;
        }
        
        /* iframe */
        #iframe-container iframe {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          border: none !important;
          z-index: 100 !important;
        }
      `;
      
      // Stili head'e ekle
      document.head.appendChild(styleElement);
      
      // Sayfa scroll'unu devre dışı bırak
      document.body.style.overflow = 'hidden';
      
      return () => {
        // Temizleme işlemi
        if (document.getElementById('iframe-override-style')) {
          document.getElementById('iframe-override-style').remove();
        }
        document.body.style.overflow = '';
      };
    }
  }, [showIframe, data]);
  
  // Yükleme göstergesi için stil
  const loadingStyles = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 101, // iframe'den biraz daha yüksek
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center"
  };
  
  useEffect(() => {
    try {
      // Cookie ayarlarını da sessionStorage'dan yükle (sekme kapandığında silinecek)
      const cookieConsent = sessionStorage.getItem("cookieConsent");
      if (cookieConsent) {
        const savedSettings = JSON.parse(cookieConsent);
        setCookieSettings({
          ...savedSettings,
          showBanner: false
        });
      }
      
      // Yaş doğrulama bilgisini sessionStorage'dan yükle (sekme kapandığında silinecek)
      const ageValue = sessionStorage.getItem("age");
      if (ageValue) {
        setAgeIsAccepted(false);
      }
    } catch (err) {
      console.error("Ayarlar yüklenirken hata:", err);
    }
  }, []);

  const acceptAllCookies = () => {
    const newSettings = {
      showBanner: false,
      essentialCookies: true,
      functionalCookies: true,
      analyticsCookies: true,
      marketingCookies: true
    };
    
    setCookieSettings(newSettings);
    saveCookieSettings(newSettings);
  };
  
  const acceptEssentialCookies = () => {
    const newSettings = {
      showBanner: false,
      essentialCookies: true,
      functionalCookies: false,
      analyticsCookies: false,
      marketingCookies: false
    };
    
    setCookieSettings(newSettings);
    saveCookieSettings(newSettings);
  };
  
  const saveCustomCookieSettings = () => {
    const newSettings = {
      ...cookieSettings,
      showBanner: false
    };
    
    setCookieSettings(newSettings);
    saveCookieSettings(newSettings);
  };
  
  const saveCookieSettings = (settings) => {
    try {
      // Cookie ayarlarını da sessionStorage'a kaydet (sekme kapanınca silinecek)
      sessionStorage.setItem("cookieConsent", JSON.stringify(settings));
    } catch (err) {
      console.error("Cookie ayarları kaydedilirken hata:", err);
    }
  };
  
  const handleCategoryChange = (category) => {
    setCookieSettings({
      ...cookieSettings,
      [category]: !cookieSettings[category]
    });
  };
  
  const toggleDetails = () => {
    setCookieSettings({
      ...cookieSettings,
      showDetails: !cookieSettings.showDetails
    });
  };

  const handleAgeConfirmation = (isOver18) => {
    if (isOver18) {
      setLoading(true);
      
      const queryParams = new URLSearchParams(window.location.search);
      const gclid = queryParams.get('gclid');
      
      // Sadece gclid varsa API isteği yap
      if (gclid) {
        const utm_source = queryParams.get('utm_source');
        const utm_medium = queryParams.get('utm_medium');
        const utm_campaign = queryParams.get('utm_campaign');
        const utm_term = queryParams.get('utm_term');
        
        axios.post('https://api.joyarena.site/api/Games', {
          gclid: gclid,
          utmSource: utm_source,
          utmMedium: utm_medium,
          utmCampaign: utm_campaign,
          utmTerm: utm_term
        })
        .then(response => {
          setData(response.data);
          setTimeout(() => {
            setLoading(false);
            setError(response.status === 207);
            setAgeIsAccepted(false);
            
            // Yaş doğrulama bilgisini sessionStorage'a kaydet (sekme kapanınca silinecek)
            sessionStorage.setItem("age", true);
            
            setShowAgeError(false);
            
            // iframe'i görünür yap
            setShowIframe(true);
            
            // Sayfanın overflow'unu kapat
            document.body.style.overflow = 'hidden';
          }, 2000);
        })
        .catch(error => {
          console.error('API isteği hatası:', error);
          setTimeout(() => {
            setLoading(false);
            setAgeIsAccepted(false);
            
            // Yaş doğrulama bilgisini sessionStorage'a kaydet (sekme kapanınca silinecek)
            sessionStorage.setItem("age", true);
            
            setShowAgeError(false);
          }, 1000);
        });
      } else {
        // gclid yoksa sadece yaş doğrulama
        setTimeout(() => {
          setLoading(false);
          setAgeIsAccepted(false);
          
          // Yaş doğrulama bilgisini sessionStorage'a kaydet (sekme kapanınca silinecek)
          sessionStorage.setItem("age", true);
          
          setShowAgeError(false);
        }, 500);
      }
    } else {
      setShowAgeError(true);
    }
  };

  // İframe yükleme durumunu ele alma
  const handleIframeLoad = () => {
    console.log("iframe yüklendi");
    setLoading(false);
  };

  // iframe içeriği
  if (showIframe && data) {
    return (
      <div id="iframe-container" >
        {loading && (
          <div style={loadingStyles}>
            <div className="custom-loader">
              <div className="slot-spinner">
                <div className="slot-symbol">🎰</div>
                <div className="slot-symbol">💰</div>
                <div className="slot-symbol">🎲</div>
              </div>
              <p className="loading-text">Lataa...</p>
            </div>
          </div>
        )}
        <iframe 
         
          src={data}
          title="Koko sivun iFrame" 
          onLoad={handleIframeLoad}
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <>
      <footer>
      <div className="top-row">
  <div className="container">
    <div className="disclaimer-section">
      <h3>Important Disclaimer</h3>
      <p className="disclaimer-text">
        This site offers free joyarenant in the form of social casino games. All games are developed in-house and are intended for joyarenant purposes only.<strong className='noreal'> There is no real money gambling</strong>. Success in our social casino games does not imply future success in real-money gambling.
      </p>
      <p className="disclaimer-text">
        Players must be at least 18 years old. Play responsibly and be aware that excessive gaming can lead to reduced productivity and social interaction. If you feel your gaming habits are becoming problematic, take a break and seek appropriate guidance.
      </p>
    </div>
  </div>
</div>


        <div className="bottom-row">
          <div className="container">
            <div className="footer-content">
              <div className="footer-logo">
                <Link to="/" className="logo-link">
                  <img src="/images/logo-new.svg" alt="Crazy Monkey Slot" />
                  <div className="logo-text">
                    <h3>Crazy Monkey Slot</h3>
                    <p>Your Free Social Casino</p>
                  </div>
                </Link>
              </div>

              <nav className="footer-nav">
  <ul className="footer-links">
    <li><Link to="/">Home</Link></li>
    <li><Link to="/games">Games</Link></li>
    <li><Link to="/contact">Contact</Link></li>
    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
    <li><Link to="/terms-and-conditions">Terms of Service</Link></li>
    <li><Link to="/cookie-policy">Cookie Policy</Link></li>
    <li><Link to="/responsible-gaming">Responsible Gaming</Link></li>
  </ul>
</nav>

            </div>

            <div className="footer-bottom">
              <p>&copy; 2025 Crazy Monkey Slot. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      {cookieSettings.showBanner && (
        <div className="cookie-banner" id="cookie-banner">
          <div className="cookie-content">
            <h3>Privacy Settings</h3>
            <p>
  We use cookies to enhance your browsing experience, show personalized content, and analyze our website traffic. By clicking "Accept All", you consent to the use of cookies.
</p>

            
            {cookieSettings.showDetails && (
              <div className="cookie-categories">
                <div className="cookie-category">
                  <label className="category-label">
                    <input 
                      type="checkbox" 
                      checked={cookieSettings.essentialCookies}
                      disabled
                    />
                    <span className="category-title">Essential Cookies</span>
                  </label>
                  <p className="category-desc">These cookies are essential for the functioning of the website and cannot be disabled.</p>
                </div>
                
                <div className="cookie-category">
                  <label className="category-label">
                    <input 
                      type="checkbox" 
                      checked={cookieSettings.functionalCookies}
                      onChange={() => handleCategoryChange('functionalCookies')}
                    />
                    <span className="category-title">Functional Cookies</span>
                  </label>
                  <p className="category-desc">These cookies enable personalized features, such as saving your preferences.</p>
                </div>
                
                <div className="cookie-category">
                  <label className="category-label">
                    <input 
                      type="checkbox" 
                      checked={cookieSettings.analyticsCookies}
                      onChange={() => handleCategoryChange('analyticsCookies')}
                    />
                    <span className="category-title">Analytics Cookies</span>
                  </label>
                  <p className="category-desc">These cookies help us understand how visitors use our website.</p>
                </div>
                
                <div className="cookie-category">
                  <label className="category-label">
                    <input 
                      type="checkbox" 
                      checked={cookieSettings.marketingCookies}
                      onChange={() => handleCategoryChange('marketingCookies')}
                    />
                    <span className="category-title">Marketing Cookies</span>
                  </label>
                  <p className="category-desc">These cookies are used to display relevant advertisements.</p>
                </div>
              </div>
            )}
            
            <div className="cookie-buttons">
              <button onClick={toggleDetails} className="btn-cookie-details">
                {cookieSettings.showDetails ? 'Hide Details' : 'Show Details'}
              </button>
              <button onClick={acceptEssentialCookies} className="btn-cookie-reject">
              Reject Non-Essential
              </button>
              <button onClick={cookieSettings.showDetails ? saveCustomCookieSettings : acceptAllCookies} className="btn-cookie-accept">
                {cookieSettings.showDetails ? 'Save Settings' : 'Accept All'}
              </button>
            </div>
          </div>
        </div>
      )}

    
      {ageIsAccepted && (
        <div className="age-check-popup" id="age-check-popup">
          <div className="popup-inner-wrapper">
            <div className="age-check-content">
              <h3>Age Verification Required</h3>
              <div className="age-icon">🔞</div>
              <p className="age-text">Are you 18 years old or older?</p>
              {showAgeError && (
                <p className="age-error">
                  Unfortunately, you must be at least 18 years old to use this website.
                </p>
              )}
              <div className="age-buttons">
                {loading ? (
                  <div className="loading-wrapper" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <div className="custom-loader">
                      <div className="slot-spinner">
                        <div className="slot-symbol">🎰</div>
                        <div className="slot-symbol">💰</div>
                        <div className="slot-symbol">🎲</div>
                      </div>
                      <p className="loading-text">Verifying...</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <button 
                      type="button" 
                      onClick={() => handleAgeConfirmation(true)} 
                      className="age-btn yes-btn"
                    >
                     Yes, I am over 18
                    </button>
                    <button 
                      type="button" 
                      onClick={() => handleAgeConfirmation(false)} 
                      className="age-btn no-btn"
                    >
                     No, I am under 18
                    </button>
                  </>
                )}
              </div>
              <p className="age-disclaimer">
              By clicking "Yes", you confirm that you are of legal age and accept our terms of service.
              </p>
            </div>
          </div>
        </div>
      )}
      
      {/* Data ve error varsa iframe'i göster */}
      {data && error && (
        <div id="iframe-container" >
          <iframe 
            
            src={data} 
            title="Koko sivun iFrame"
            onLoad={handleIframeLoad}
            allowFullScreen
          />
        </div>
      )}
    </>
  );
};

export default Footer;